module.exports = __webpack_public_path__ + "static/media/features-split-image-03.4f2ed92d.png";